import { useTranslation } from 'react-i18next';
import { User } from 'shared/@types';
import { fasShieldCheck } from 'shared/@generated/icons/fasShieldCheck';
import { Icon } from 'shared/components/icon';
import { Tooltip } from 'shared/components/tooltip';

export function IdentityBadge({
  verifiedAt,
  className = 'size-4',
  testID = 'identity-badge',
}: {
  verifiedAt?: User['verified_at'];
  className?: string;
  testID?: string;
}) {
  const { t } = useTranslation('components');

  if (!verifiedAt) {
    return null;
  }

  return (
    <Tooltip content={t('user_card.verified_identity')} className={'shrink-0'} testID={testID}>
      <Icon icon={fasShieldCheck} className={`text-blue-500 ${className}`} />
    </Tooltip>
  );
}
